/**
 * 语言检测工具函数
 * @author NUXT 技术专家
 * @created 2024/12/19
 * @description 基于 host 判断语言类型的公共函数
 */

/**
 * 根据 host 判断语言类型
 * @param host 主机名
 * @returns 'cn' | 'en'
 */
export function getLanguageByHost(host?: string): 'cn' | 'en' {
  // 如果 host 包含端口，去除端口部分
  if (host) {
    host = host.split(':')[0]
  }
  
  if (!host) {
    // 开发环境下输出警告
    if (process.env.NODE_ENV === 'development') {
      console.warn('[Language Detection] 未获取到 host，默认返回中文')
    }
    return 'cn'
  }
  
  // 英文站点的域名匹配规则
  const englishHosts = [
    'en.jufair.com',
    'dev-en.jufair.com',
    'pre-pc-en.jufair.com',
    'vue-en.jufair.com',
  ]
  
  // 中文站点的域名匹配规则  
  const chineseHosts = [
    'www.jufair.com',
    'jufair.com',
    'cn.jufair.com',
    'mmvue.jufair.com',
    'mmmvue.jufair.com',
    'pre-pc.jufair.com',
    'visa-dev.jufair.com',
    'visa.jufair.com'
  ]
  
  // 精确匹配
  if (englishHosts.includes(host)) {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Language Detection] 检测到英文站点: ${host} -> en`)
    }
    return 'en'
  }
  
  if (chineseHosts.includes(host)) {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Language Detection] 检测到中文站点: ${host} -> cn`)
    }
    return 'cn'
  }
 
  // 默认返回中文
  if (process.env.NODE_ENV === 'development') {
    console.log(`[Language Detection] 未识别的域名: ${host}，默认返回中文`)
  }
  return 'cn'
}

/**
 * 检查是否为英文站点
 * @param host 主机名
 * @returns boolean
 */
export function isEnglishSite(host?: string): boolean {
  return getLanguageByHost(host) === 'en'
}

/**
 * 检查是否为中文站点
 * @param host 主机名
 * @returns boolean
 */
export function isChineseSite(host?: string): boolean {
  return getLanguageByHost(host) === 'cn'
}
